import {Column} from "react-table";
import {TableCustomCell} from "../../../../component/table/components/TableCustomCell";
import {DanhSachPhieuInterface} from "../models/KeHoachModel"
import {TableCustomHeader} from "../../../../component/table/components/TableCustomHeader";
import {formatDateToDDMMYYYY} from "../../../../utils/FormatUtils";

export const DanhSachPhieuColumns: ReadonlyArray<
  Column<DanhSachPhieuInterface>
> = [
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "stt",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center "
        data={String(props?.row?.index + 1)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="TT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "custom",
    Cell: ({...props}) => (
      <div className="text-center">
        <i className="bi bi-circle-fill" style={{color: props.data[props.row.index]?.color}}></i>
      </div>
    )
    ,
  },
  {
    Header: (props) => (
        <TableCustomHeader<DanhSachPhieuInterface>
            tableProps={props}
            title="Mã phiếu"
            className="text-center text-white align-middle bg-pri spaces w-140px"
        />
    ),
    id: "code",
    Cell: ({...props}) => (
        <TableCustomCell
            className="text-center s-2"
            data={props.data[props.row.index]?.code}
        />
    ),
  },
  {
    Header: (props) => (
        <TableCustomHeader<DanhSachPhieuInterface>
            tableProps={props}
            title="Tên phiếu"
            className="text-center text-white align-middle bg-pri"
        />
    ),
    id: "name",
    Cell: ({...props}) => (
        <TableCustomCell
            className="text-left s-2"
            data={props.data[props.row.index]?.name}
        />
    ),
  },
  {
    Header: (props) => (
        <TableCustomHeader<DanhSachPhieuInterface>
            tableProps={props}
            title="Ngày bắt đầu"
            className="text-center text-white align-middle bg-pri spaces w-140px"
        />
    ),
    id: "startDate",
    Cell: ({...props}) => (
        <TableCustomCell
            className="text-center s-2"
            data={formatDateToDDMMYYYY(props.data[props.row.index]?.startDate)}
        />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<DanhSachPhieuInterface>
        tableProps={props}
        title="Ngày kết thúc"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "endDate",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={formatDateToDDMMYYYY(props.data[props.row.index]?.endDate)}
      />
    ),
  },
];